import { useApp } from '../store/AppContext'

export function EventResponseInline({ eventId }: { eventId: string }) {
  const { currentUser, events, respondToEvent } = useApp()
  const event = events.find((e) => e.id === eventId)
  if (!event) return null

  const mine = event.assignees.find((a) => a.userId === currentUser.id)
  if (!mine) return null

  if (mine.status === 'pending') {
    return (
      <div className="mt-2 flex gap-2">
        <button
          onClick={() => respondToEvent(eventId, 'declined')}
          className="flex-1 rounded-xl border border-rose-300 bg-white py-1.5 text-xs font-bold text-rose-600"
        >
          Decline
        </button>
        <button
          onClick={() => respondToEvent(eventId, 'accepted')}
          className="flex-1 rounded-xl bg-emerald-600 py-1.5 text-xs font-bold text-white"
        >
          Accept
        </button>
      </div>
    )
  }

  return (
    <p className={`mt-1.5 text-[11px] font-semibold ${mine.status === 'accepted' ? 'text-emerald-600' : 'text-rose-600'}`}>
      {mine.status === 'accepted' ? '✅ You accepted' : '❌ You declined'}
    </p>
  )
}

